/**
 * Validation for Provider name and clinic fields.
 *
 **/
export const PROVIDER_NAME_BLOCKED_PATTERN = /["<>]|\p{C}|[^\S ]/u

export const PROVIDER_NAME_ERROR = 'Cannot contain " < > or invisible characters'

export const validateNameField = (value) => {
  if (value && PROVIDER_NAME_BLOCKED_PATTERN.test(value)) {
    return PROVIDER_NAME_ERROR
  }
  return undefined
}

export const PROVIDER_NAME_FIELDS = ['firstName', 'middleName', 'lastName', 'suffixName', 'clinicName']

export const trimNameFields = (data) => {
  const trimmed = { ...data }
  PROVIDER_NAME_FIELDS.forEach((field) => {
    if (typeof trimmed[field] === 'string') {
      trimmed[field] = trimmed[field].trim()
    }
  })
  return trimmed
}
